var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"loader",class:{
    'loader--small': _vm.data.attrs && typeof _vm.data.attrs['small'] === 'string',
  }},[_c('div',{staticClass:"loader__spinner",style:({
      'border-color': _vm.data.attrs && _vm.data.attrs.color,
      height: _vm.data.attrs && _vm.data.attrs.size,
      width: _vm.data.attrs && _vm.data.attrs.size,
      'border-width': _vm.data.attrs && _vm.data.attrs.width,
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }